import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { Expense, ExpenseDetail, ExpenseCreate, ExpenseUpdate } from '@core/types/finance.type';
import { PaginationResult, PaginationConfig } from './unit.service';
import { buildPaginationBody } from '@core/utils/pagination.util';

@Injectable({ providedIn: 'root' })
export class ExpenseService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/finance/expenses`;

  getExpenses(config: PaginationConfig): Observable<ApiResponse<PaginationResult<Expense>>> {
    return this.http.post<ApiResponse<PaginationResult<Expense>>>(`${this.apiUrl}/grid`, buildPaginationBody(config));
  }

  getExpense(id: string): Observable<ApiResponse<ExpenseDetail>> {
    return this.http.get<ApiResponse<ExpenseDetail>>(`${this.apiUrl}/${id}`);
  }

  createExpense(data: ExpenseCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.apiUrl, data);
  }

  updateExpense(data: ExpenseUpdate): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(this.apiUrl, data);
  }

  deleteExpense(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }

  markExpenseAsPaid(id: string, paidDate: string, reference?: string): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${id}/mark-paid`, { paidDate, reference });
  }
}
